import http from "./../shared/axios";
import { Sbicard_Details,Get_Products_Data } from "../shared/ServiceCommonEndpoints";
class CardDetailsService {

    funcFetchCardDetails(cardPath) {        
        return http.get(Sbicard_Details + cardPath, { headers: { "channel": "sbicard" }});
    }
    funcFetchProductData(payload) {
        return http.post(Get_Products_Data,  payload,
            {
              headers: {
                "IDENTIFIER_1": localStorage.getItem("visitorID"),
                "IDENTIFIER_2": localStorage.getItem("anonymous_id")
              }
            });
    }

}
// eslint-disable-next-line
export default new CardDetailsService(); 